import React from 'react';
import PropTypes from 'prop-types';
import Floater from 'react-floater';

import {pushAnalyticsEvent} from '../../organisms/Analytics';
import {NEW_CYBERSOURCE_PAYMENT_FORM} from '../../../consts';
import assetUrl from '../../../utils/assetUrl';

const imgDir = assetUrl('images');

class CyberSourceCvvField extends React.Component {
    microformField = null

    popupRef = React.createRef()

    popupButtonRef = React.createRef()

    state = {cvvHelpPopupIsOpen: false}

    componentDidMount() {
        document.addEventListener('mousedown', this.closePopupOnOutsideClick);
    }

    componentWillReceiveProps(nextProps) {
        if (this.microformField === null && nextProps.microformField !== null) {
            this.microformField = nextProps.microformField;
            this.microformField.on('change', this.onChange);
            this.microformField.on('blur', this.onBlur);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closePopupOnOutsideClick);
        if (this.microformField) {
            this.microformField.off('change', this.onChange);
            this.microformField.off('blur', this.onBlur);
        }
    }

    closePopupOnOutsideClick = event => {
        const popupClick = this.popupRef?.current.contains(event.target);
        const popupButtonClick = this.popupButtonRef?.current.contains(event.target);
        if (!popupClick && !popupButtonClick) {
            this.hideHelpPopup();
        }
    }

    onBlur = () => {
        const {form: {setFieldTouched}, field: {name}} = this.props;
        pushAnalyticsEvent({
            interactionName: 'form tracking',
            formName: NEW_CYBERSOURCE_PAYMENT_FORM,
            formField: name
        });
        setFieldTouched(name, true);
    }

    toggleHelpPopup = () => {
        this.setState(state => ({cvvHelpPopupIsOpen: !state.cvvHelpPopupIsOpen}));
    }

    hideHelpPopup = () => {
        this.setState({cvvHelpPopupIsOpen: false});
    }

    onChange = data => {
        const {form: {setFieldValue}, field: {name}} = this.props;
        setFieldValue(name, data);
    }

    render() {
        const {
            id,
            translations: {cvvHelpInfo}
        } = this.props;
        const {cvvHelpPopupIsOpen} = this.state;

        return (
            <div className="cvv-wrapper">
                <div id={id} className="flex-microform"> </div>
                <button
                    type="button"
                    ref={this.popupButtonRef}
                    onClick={this.toggleHelpPopup}
                    tabIndex="-1"
                    className="popup-target-button"
                >
                    <img
                        className="cvv-icon"
                        src={`${imgDir}/cvc.svg`}
                        alt="back side of card"
                    />
                </button>
                <Floater
                    autoOpen={false}
                    placement="bottom-end"
                    open={cvvHelpPopupIsOpen}
                    target=".popup-target-button"
                    styles={{
                        container: {
                            padding: '1.2rem 1rem 1rem 1rem',
                            minWidth: '19rem',
                            minHeight: '10.25rem'
                        },
                        arrow: {
                            length: 14,
                            spread: 24,
                            margin: 10
                        }
                    }}
                    content={(
                        <div className="floater" ref={this.popupRef}>
                            <button
                                className="popup-close-btn"
                                type="button"
                                onClick={this.hideHelpPopup}
                                style={{backgroundImage: `url(${imgDir}/close.svg)`}}
                            />
                            <h2 className="help-popup-title">{cvvHelpInfo.titleThreeDigits}</h2>
                            <div className="help-popup-content">
                                <img
                                    className="cvv-icon-popup"
                                    src={`${imgDir}/cvc-large.png`}
                                    srcSet={`${imgDir}/cvc-large@2x.png 2x, ${imgDir}/cvc-large@3x.png 3x`}
                                    alt="back side of card"
                                />
                                <span className="help-popup-side-text">
                                    {cvvHelpInfo.text}
                                </span>
                            </div>
                        </div>
                    )}
                />
            </div>
        );
    }
}

CyberSourceCvvField.getInitialFieldValues = () => ({
    empty: true,
    valid: false
});

CyberSourceCvvField.defaultProps = {
    microformField: null
};

CyberSourceCvvField.propTypes = {
    id: PropTypes.string.isRequired,
    microformField: PropTypes.shape(),
    field: PropTypes.shape({
        name: PropTypes.string.isRequired
    }).isRequired,
    form: PropTypes.shape({
        setFieldValue: PropTypes.func.isRequired,
        setFieldTouched: PropTypes.func.isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired
};

export default CyberSourceCvvField;
